import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import Icon from '../Icon';
import LinkCopyButton from '../LinkCopyButton';
import DateTimeIntervalDisplay from '../DateTimeIntervalDisplay';
import ModalTrigger from '../ModalTrigger';


export default class StaffEventsList extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    timezone: moment.tz.guess(),
    defaultSort: null,
    apiUrl: '',
  }

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <div className="u-truncate">
          <span
            style={{ lineHeight: '2rem' }}
            className={`u-text-center u-align-middle u-bg-old-${item.type.dash}-light u-border-old-${item.type.dash} u-font-semibold u-mr-2 u-border u-w-8 u-inline-block`}
          >
            {item.type.initials}
          </span>
          <a className="u-font-semibold" href={item.staff_url}>{item.name}</a>
        </div>
      </td>
      <td>
        <div className="u-truncate">
          <div className="u-inline-block u-mr-4">
            { item.hosts
                && item.hosts.map(host => (
                  <Avatar
                    className="StaffTable-avatar Avatar--facepile Avatar--facepile-frozen u-align-middle"
                    src={host.avatar_url}
                    type={host.type}
                    href={host.staff_url}
                    showInitials
                    name={host.name}
                  />
                ))}
          </div>
          { item.hosts
              && item.hosts.map(host => (
                <a
                  className="u-font-semibold comma-separated"
                  href={host.staff_url}
                >
                  {host.name}
                </a>
              ))}
        </div>
      </td>
      <td>
        <div className="u-truncate">
          {item.campus.map((campus) => (
            <span className="comma-separated">{campus}</span>
          ))}
        </div>
      </td>
      <td>
        {this.currentIndicator(item)}
        <DateTimeIntervalDisplay
          useTimezone={this.props.timezone}
          start_date={item.start_date}
          end_date={item.end_date}
          show_timezone={false}
          />
      </td>
      <td>
        {item.views_count}
      </td>
      <td>
        <ModalTrigger
          async
          asyncUrl={item.summary_url}
          triggerClassName="u-cursor-pointer"
        >
          {item.rsvps_count}
          {
            item.max_attendees
            && (
              <>
                &nbsp;/&nbsp;
                {item.max_attendees}
              </>
            )
          }
        </ModalTrigger>
      </td>
      <td>
        {item.usage_rate === null ? 'N/A' : this.renderUsageRate(item.usage_rate)}
      </td>
      <td>
        {this.renderState(item.state)}
      </td>
      <td className="actions">
        <a href={item.edit_staff_url} className="Button u-mr-2">
          <Icon name="edit" className="u-mr-0" />
        </a>
        <div className="u-inline-block">
          <LinkCopyButton url={item.public_url} name={item.name} />
        </div>
      </td>
    </tr>
  );

  currentIndicator = (item) => {
    if (Date.now() < (new Date(item.end_date)).getTime() && Date.now() > (new Date(item.start_date)).getTime()) {
      return (
        <div className="indicator-current" />
      );
    }
  }

  renderState = (state) => {
    let pillClass = 'status-pill--';
    let display = null;
    switch (state) {
      case ('active'):
      case ('bookable'):
        pillClass += 'published';
        display = 'Available';
        break;
      case ('fully_booked'):
      case ('past_cutoff'):
        pillClass += 'draft';
        display = 'Unavailable';
        break;
      case ('canceled'):
        pillClass += 'archived';
        display = 'Canceled';
        break;
      default:
    }
    return (<div className={`status-pill ${pillClass}`}>{display}</div>);
  }

  renderUsageRate = (rating) => {
    const num = Number.parseFloat(rating);
    let score = 'u-text-red';
    if (num >= 75) {
      score = 'u-text-green-success';
    } else if (num >= 50) {
      score = 'u-text-another-toasted-yellow';
    }
    let display = num.toFixed(0);
    display = display.endsWith('.0') ? display.slice(0, -2) : display;
    return (
      <span className={score}>
        {display}
        %
      </span>
    );
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow}
      />
    );
  }
}
